export default __webpack_public_path__ + "static/media/AURPauseButton.4cb805d6.svg";